import PwtTransactionTable from "../misc/PwtTransactionTable";

export default function PwtTransactions() {
  return <PwtTransactionTable />;
}
